module.exports = __webpack_public_path__ + "media/images/emblems/Champery-2328c40ce3a20f0d2ca2f241a328abee.png";